module.exports = __webpack_public_path__ + "img/CZ06325416.1f22ff97.png";